// initial state
const state = {}

// getters
const getters = {}

// actions
const actions = {
  workInfoBusinessTypeQuery: ({commit, state}, params) => request.alert('workInfoBusinessTypeQuery', params),
  workInfoBusinessTypeCreate: ({commit, state}, params) => request.alert('workInfoBusinessTypeCreate', params),
  workInfoBusinessTypeEdit: ({commit, state}, params) => request.alert('workInfoBusinessTypeEdit', params),
  workInfoBusinessTypeGet: ({commit, state}, params) => request.alert('workInfoBusinessTypeGet', params),
  workInfoBusinessTypeDelete: ({commit, state}, params) => request.alert('workInfoBusinessTypeDelete', params),
}

// mutations
const mutations = {}

export const workInfoBusinessType = {
  state,
  getters,
  actions,
  mutations,
}




// WEBPACK FOOTER //
// ./src/views/work-info-business-type/work-info-business-type.store.js